<template>
    <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
    <div class="about">
        <section class="section page-wrapper">
            <figure class="section-image section-image--full-width demo">
                <img
                    src="~/assets/images/about-us-heading.webp"
                    :alt="$t('pages.about.heading_img_alt')"
                    class="section-image__image"
                />
            </figure>
            <div class="section__content">
                <h1 class="section__heading">
                    {{ $t('pages.about.heading') }}
                </h1>
                <p>
                    {{ $t('pages.about.intro_desc1') }}
                </p>
                <p>
                    {{ $t('pages.about.intro_desc2') }}
                </p>
                <p>
                    {{ $t('pages.about.intro_desc3') }}
                </p>
                <h2 class="section__subheading">{{ $t('pages.about.freedom_subheading') }}</h2>
                <p>
                    {{ $t('pages.about.freedom_desc') }}
                </p>
                <h2 class="section__subheading">{{ $t('pages.about.sharing_heading') }}</h2>
                <p>
                    {{ $t('pages.about.sharing_desc1') }}
                </p>
                <p>
                    {{ $t('pages.about.sharing_desc2') }}
                </p>
            </div>

            <div v-if="isAdmin">
                <Notice type="warning">Refetch employees (admin only)</Notice>
                <button @click="updateEmployees">Refetch employees</button>
            </div>

            <div class="team">
                <h2 class="section__heading">{{ $t('pages.about.team_subheading') }}</h2>
                <div class="persons">
                    <div v-for="(person, index) in people" :key="index" class="person">
                        <img
                            v-if="person.image"
                            v-lazy-load-image="person.image"
                            :alt="person.name"
                            class="person__image"
                        />
                        <div v-else class="avatar person__image">
                            <svg-icon name="person" />
                        </div>
                        <p class="person__name">{{ person.name }}</p>
                        <p class="person__title">{{ person.title }}</p>
                    </div>
                </div>
            </div>
            <Contact />
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Contact from '~/components/sections/Contact.vue';
import AboutUsService from '~/services/AboutUsService';

export default {
    components: {
        Contact,
    },
    data() {
        return {
            people: [],
        };
    },
    async fetch() {
        this.people = await new AboutUsService(this).getEmployees();
    },
    head() {
        return {
            title: this.$t('pages.about.heading'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.pageDescription,
                },
            ],
        };
    },
    computed: {
        ...mapGetters(['isAdmin']),
        pageDescription() {
            if (this.$store.getters.isCountryFinland) {
                return this.$t('pages.about.seo_page_desc_fi');
            }

            return this.$t('pages.about.seo_page_description', {
                siteName: this.$config.siteName,
                siteCountry: this.$t(`localization.countries.${this.$store.getters.siteCountryCodeWithFallback}`),
            });
        },
    },
    methods: {
        async updateEmployees() {
            this.people = await new AboutUsService(this).getEmployees(true);
        },
    },
    nuxtI18n: {
        paths: {
            se: '/om-oss',
            'fi-sv': '/om-oss',
            fi: '/tietoa-meista',
            en: '/about-us',
            de: '/ueber-uns',
            at: '/ueber-uns',
            no: '/om-oss',
            dk: '/om-os',
            ch: '/ueber-uns',
            fr: '/a-propos',
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.section {
    &__content {
        max-width: 680px;
    }
}

.section-image {
    &__image {
        border-radius: 20px;
    }

    @include lg {
        margin-left: 20px;
        margin-right: 20px;
    }
}

.about {
    &__header {
        @extend %heading-2;
        text-align: center;
        margin-bottom: 10px;
    }

    .team {
        max-width: 1040px;
        margin: 100px auto 0;
    }

    .persons {
        display: grid;
        grid-column-gap: 8px;
        grid-row-gap: 30px;
        grid-template-columns: repeat(1, 1fr);

        @include sm {
            grid-template-columns: repeat(2, 1fr);
        }

        @include lg {
            grid-template-columns: repeat(4, 1fr);
            grid-column-gap: 30px;
        }
    }

    .person {
        &__image {
            width: 200px;
            height: 200px;
            object-fit: cover;
            border-radius: $default-border-radius;
            display: block;
            margin-bottom: 10px;
            margin-left: auto;
            margin-right: auto;
        }
        &__name {
            margin: 5px auto;
            font-weight: 600;
        }
        &__title {
            margin-bottom: 20px;
            color: $secondary-text-color;
        }
    }
}

.avatar {
    object-position: center;
    background: $gray-light;
    margin: auto;

    .svg-icon {
        color: $gray;
        width: 100%;
        height: 100%;
    }
}
</style>
